<script setup lang="ts"></script>

<template>
  <footer class="text-center text-white" style="background-color: #f1f1f1">
    <div
      class="text-center text-black p-4"
      style="background-color: rgba(0, 0, 0, 0.2)"
    >
      © {{ new Date().getFullYear() }} Copyright:
      <a class="text-gray-800" href="https://pexelry.netlify.app"> Pexelry</a>
    </div>
  </footer>
</template>
